import * as types from '../../../../../../lib/actionTypes.es6'
import { isPendingApproval } from '../../../../../../lib/premiumApprovals'

export const initialState = {

  get_premiums_errors: null,
  get_premiums_loader: false,
  get_premiums_success_message: '',
  premiums: [],

  premiumToRemove: null,
  removeComplexPremiumLoader: false,
  removeComplexPremiumSuccess: false,
  removeComplexPremiumPending: false,
  removeComplexPremiumError: null,

};

export default function accessBankPremiumsReducer(state = initialState, action) {
  switch (action.type) {

    case types.GET_ALL_ACCESSBANK_CUSTOMER_PREMIUMS_REQUEST:
      return { ...state, get_premiums_loader: true, get_premiums_errors: null };
    case types.GET_ALL_ACCESSBANK_CUSTOMER_PREMIUMS_SUCCESS:
      return { ...state, get_premiums_loader: false, get_premiums_errors: null, premiums: action.payload };
    case types.GET_ALL_ACCESSBANK_CUSTOMER_PREMIUMS_FAILURE:
      return { ...state, get_premiums_loader: false, get_premiums_errors: action.payload };

    case types.SET_PREMIUM_TO_REMOVE:
      return { ...state, premiumToRemove: action.payload };
    case types.RESET_PREMIUM_TO_REMOVE:
      return { ...state, premiumToRemove: null };
    case types.REMOVE_COMPLEX_PREMIUM_REQUEST:
      return { ...state, removeComplexPremiumLoader: true, removeComplexPremiumError: null };
    case types.REMOVE_COMPLEX_PREMIUM_SUCCESS:
      return {
        ...state,
        removeComplexPremiumLoader: false,
        removeComplexPremiumSuccess: true,
        removeComplexPremiumPending: isPendingApproval(action.payload),
      };
    case types.REMOVE_COMPLEX_PREMIUM_FAILURE:
      return { ...state, removeComplexPremiumLoader: false, removeComplexPremiumError: action.payload };
    case types.RESET_REMOVE_COMPLEX_PREMIUM_SUCCESS:
      return { ...state, removeComplexPremiumSuccess: false, removeComplexPremiumPending: false };
    case types.RESET_REMOVE_COMPLEX_PREMIUM_ERROR:
      return { ...state, removeComplexPremiumError: null };

    default:
      return state;
  }
}